import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class DocumentNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    switch (this.subtype) {
      case 'referral-letter':
        this.description = this.translateService.instant('view_referral_letter_from_doctor', { doctor: data?.document?.doctor });
        this.actionName = this.translateService.instant('view_referral_letter');
        break;
      case 'sicknote':
        this.description = this.translateService.instant('view_sick_note_from_doctor', { doctor: data?.document?.doctor });
        this.actionName = this.translateService.instant('view_sick_note');
        break;
      default:
        this.description = this.translateService.instant('view_document_description', {
          subtype: this.subtype,
          doctor: data?.document?.doctor,
        });

        this.actionName = this.translateService.instant('view_document_action', {
          subtype: this.subtype,
        });
        break;
    }
    this.actionRequired = !this.readDate;
  }
}
